import { auth } from '../../utils';
import config from '../../config';

export const updateMfaTokenApi = async (
  isEnabled: Boolean,
  MFAToken?: String,
) => {
  if (!MFAToken && isEnabled === true) {
    return true;
  }
  const userGuid = auth.getAccessToken()?.guid;
  const url = `${config.mfaIssueTokenCheck.baseUrl}${userGuid}/mfa/update`;

  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Authorization: `Bearer ${auth.getParsedAuthCookie()?.accessToken}`,
    },
    method: 'POST',
    body: JSON.stringify({
      MFAEnabled: isEnabled,
      MFAToken: MFAToken,
    }),
    credentials: 'include',
  });

  if (!response.ok && response.statusText === 'Forbidden') {
    throw new Error(response.statusText);
  } else if (!response.ok) {
    throw new Error('No response');
  }

  const json = await response.json();

  return json;
};
